export const validateUUID = (attempt?: string) => {
  const pattern =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

  if (!attempt) return false;

  return attempt.match(pattern);
};
